export const formatDateToUs = (oldDate: string) => {
  if (oldDate.length !== 10) {
    return oldDate;
  }

  const arr = oldDate.split('/');

  return arr[2] + '-' + arr[1] + '-' + arr[0];
};

export const formatDateToBr = (oldDate: string) => {
  if (oldDate.length !== 10) {
    return oldDate;
  }

  const arr = oldDate.split('-');

  return arr[2] + '/' + arr[1] + '/' + arr[0];
};
